import IGeronimo from "./geronimo.interface";

export interface IUrlInfo {
  source: string;
  country: string;
  vin: string;
  divisionId?: string;
  reschedule?: string;
  scheduleId?: string;
  advisorId?: string;
  scheduleHour?: string;
  scheduleDate?: string;
  coordinate?: {
    lat?: string;
    lng?:string;
  }
  dealerId?: string;
  geronimo?: IGeronimo;
}
